<template>
  <div class="row section-bottom-spacing">
    <div class="col">
      <SectionTitle :content="'Asuntos Discutidos'" :has-line="true" />
      <div class="list-group mt-4">
        <div href="#" class="list-group-item active p-3">
          Elija el o los asuntos discutidos
        </div>
        <div
          v-for="(item, index) in model.subjects"
          :key="index"
          class="list-group-item list-group-item-action"
        >
          <div class="form-group">
            <div class="input-group mb-3">
              <input
                :id="'check-' + item.discussion.id"
                v-model="item.isSelected"
                type="checkbox"
                :name="'check-' + item.discussion.id"
                class="option-input checkbox"
                :checked="item.isSelected"
                :disabled="readonly"
                @change="onChange"
              />
              <label :for="'check-' + item.discussion.id">
                <span><i class="ic-check" /></span>
                <p class="inline" v-html="item.discussion.description" />
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-5">
        <p>Otros asuntos relacionados a la discusión de la evaluación:</p>
        <CustomTextArea
          v-show="true"
          :id="'othersSubject'"
          v-model="model.othersSubject"
          style="width:100%"
          :maxlength="3000"
          :classes="['eq-field', 'text-left']"
          :rows="5"
          :disabled="readonly"
          @input="onChange"
        />
        <span class="invalid">{{ errorMessageComment }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import CustomTextArea from '@/components/common/CustomTextArea';
import { SectionTitle } from '@/components/pei/shared';
export default {
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    peiAtInformation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isValid: false,
      currentDate: null,
      errorMessageComment: '',
      errorMessageCheck: '',
      errorMessage: '',
    };
  },
  components: {
    SectionTitle,
    CustomTextArea,
  },
  methods: {
    validate() {
      this.errorMessageComment = '';
      this.errorMessageCheck = '';
      this.errorMessage = '';
      this.isValid = true;

      if (!this.model.othersSubject) {
        this.errorMessageComment = this.getMessage('0675').name;
        this.errorMessage = this.errorMessageComment;
        this.isValid = false;
      }

      if (!this.peiAtInformation.isRecomendationNeeded) {
        if (
          this.model.subjects.findIndex(
            (x) =>
              !x.isSelected &&
              (x.discussion.id === 1 ||
                x.discussion.id === 2 ||
                x.discussion.id === 6)
          ) !== -1
        ) {
          this.errorMessage = this.getMessage('R03200048').name;
          this.isValid = false;
        }
      } else if (this.model.subjects.findIndex((x) => !x.isSelected) !== -1) {
        this.errorMessage = this.getMessage('191357').name;
        this.isValid = false;
      }

      this.$emit('changed', 2, this.isValid, this.errorMessage);
      return this.isValid;
    },
    showMessage() {},
    loadValidationMessages() {
      const messageCodes = ['0675', '191357', 'R03200048'];
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      promise.then((res) => {
        this.validationMessages = res.data;
      });
    },
    getMessage(code) {
      const message = this.validationMessages.find(
        (element) => element.id == code
      );
      return message;
    },
    onChange() {
      this.validate();
    },
  },
  created() {
    this.loadValidationMessages();
  },
  mounted() {},
};
</script>

<style scoped src="@/assets/css/component/checkbox.css"></style>

<style scoped>
.list-group-item.active {
  background-color: #3f5b60 !important;
  border: none;
}

.input-group .hidden {
  display: none;
}

.input-group .entry {
  height: 25px;
  position: relative;
  width: 110px;
}

.input-group .highlight {
  background: #2db782;
  border-radius: 50%;
  height: 10px;
  left: 5px;
  pointer-events: none;
  position: absolute;
  top: 5px;
  transition: transform 400ms cubic-bezier(0.175, 0.885, 0.32, 1.2);
  transform: translateX(0px);
  width: 10px;
}

.input-group .h idden:nth-child(1):checked ~ .highlight {
  transform: translateY(0);
}

.input-group .hidden:nth-child(3):checked ~ .highlight {
  transform: translateX(110px);
}

.input-group .hidden:nth-child(1):checked + .entry .circle {
  border-color: #e2e2e2;
}
.inline {
  display: inline;
}
</style>
